import type { EmergencyDrillResult, EmergencyPlanStatus, EmergencyScenario } from './types';

export const SCENARIO_LABEL: Record<EmergencyScenario, string> = {
  incendio: 'Incendio',
  derrame: 'Derrame',
  sismo: 'Sismo',
  evacuacion: 'Evacuación',
  otro: 'Otro',
};

export const PLAN_STATUS_LABEL: Record<EmergencyPlanStatus, string> = {
  activo: 'Activo',
  inactivo: 'Inactivo',
};

export const DRILL_RESULT_LABEL: Record<EmergencyDrillResult, string> = {
  satisfactorio: 'Satisfactorio',
  con_hallazgos: 'Con hallazgos',
  no_satisfactorio: 'No satisfactorio',
};

export function scenarioBadgeClass(scenario: EmergencyScenario): string {
  const map: Record<EmergencyScenario, string> = {
    incendio: 'bg-red-100 text-red-800',
    derrame: 'bg-amber-100 text-amber-800',
    sismo: 'bg-orange-100 text-orange-800',
    evacuacion: 'bg-blue-100 text-blue-800',
    otro: 'bg-gray-100 text-gray-800',
  };
  return map[scenario];
}

export function planStatusBadgeClass(status: EmergencyPlanStatus): string {
  return status === 'activo' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600';
}

export function drillResultBadgeClass(result: EmergencyDrillResult): string {
  const map: Record<EmergencyDrillResult, string> = {
    satisfactorio: 'bg-green-100 text-green-800',
    con_hallazgos: 'bg-amber-100 text-amber-800',
    no_satisfactorio: 'bg-red-100 text-red-800',
  };
  return map[result];
}

export function upcomingStateBadgeClass(state: 'upcoming' | 'overdue'): string {
  return state === 'overdue' ? 'bg-red-100 text-red-800' : 'bg-amber-100 text-amber-800';
}

export function upcomingStateLabel(state: 'upcoming' | 'overdue', daysUntilDue: number): string {
  if (state === 'overdue') {
    return `Vencido (${Math.abs(daysUntilDue)} d)`;
  }
  return `En ${daysUntilDue} d`;
}
